import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={120}
      height={120}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        d="M94.249 72.99c-13.904 0-24.795-2.52-24.795-5.736 0-1.929 3.86-3.65 10.588-4.72a.186.186 0 01.213.153.186.186 0 01-.155.212c-6.338 1.01-10.276 2.678-10.276 4.355 0 2.908 11.185 5.366 24.425 5.366 13.239 0 24.424-2.458 24.424-5.366 0-1.684-3.962-3.357-10.341-4.366a.185.185 0 11.058-.365c6.77 1.07 10.653 2.795 10.653 4.73 0 3.217-10.891 5.737-24.794 5.737z"
        fill="#CCC"
      />
      <Path
        d="M81.948 74.07a14.246 14.246 0 0024.637-.062c-8.205.472-16.43.493-24.637.062zM107.949 70.052a14.242 14.242 0 00-2.352-12.52 14.25 14.25 0 00-17.787-4.096A14.247 14.247 0 0080.59 70.2a105.882 105.882 0 0027.359-.148z"
        fill="#E6E6E6"
      />
      <Path
        d="M23.104 17.665A1.666 1.666 0 1020.79 19.2v8.642h1.295V19.2a1.665 1.665 0 001.018-1.535zM32.448 59.112a3.706 3.706 0 01-3.698-3.843c.074-1.962 1.773-3.558 3.786-3.558h10.167l8.366-3.703a.926.926 0 011.22.47l2.247 5.077a.926.926 0 01-.471 1.22l-8.24 3.648a6.55 6.55 0 01-2.59.564l-10.787.125zM7.804 78.604a.846.846 0 01-.143-.012l-5.472-.934a.834.834 0 01-.677-.98l4.283-21.844a3.608 3.608 0 117.113 1.216l-4.29 21.882a.827.827 0 01-.814.672z"
        fill="#CCC"
      />
      <Path
        d="M4.878 83.352a3.33 3.33 0 100-6.661 3.33 3.33 0 000 6.66zM21.035 51.466c6.847 0 12.398-5.55 12.398-12.397s-5.55-12.397-12.398-12.397c-6.847 0-12.397 5.55-12.397 12.397s5.55 12.397 12.397 12.397z"
        fill="#E6E6E6"
      />
      <Path
        d="M21.035 51.466c6.847 0 12.398-5.55 12.398-12.397s-5.55-12.397-12.398-12.397c-6.847 0-12.397 5.55-12.397 12.397s5.55 12.397 12.397 12.397z"
        fill="#E6E6E6"
      />
      <Path
        d="M21.035 48.506a9.437 9.437 0 100-18.873 9.437 9.437 0 000 18.873z"
        fill="#E40046"
      />
      <Path
        d="M22.139 43.03c-.612-.017-1.373-.038-1.96-.466a1.505 1.505 0 01-.592-1.124 1.013 1.013 0 01.344-.831c.306-.26.754-.32 1.236-.178l-.5-3.65.367-.05.587 4.29-.306-.14c-.355-.163-.842-.246-1.145.01a.65.65 0 00-.213.536 1.138 1.138 0 00.44.838c.457.333 1.064.376 1.752.395l-.01.37zM18.854 37.096h-1.993v.37h1.993v-.37zM25.145 37.096h-1.993v.37h1.993v-.37z"
        fill="#2F2E41"
      />
      <Path
        opacity={0.2}
        d="M14.684 39.129a9.439 9.439 0 018.007-9.329 9.435 9.435 0 10-.15 18.631 9.438 9.438 0 01-7.857-9.302z"
        fill="#000"
      />
      <Path
        d="M30.472 78.633H11.599a3.057 3.057 0 01-3.053-3.053V54.301a3.056 3.056 0 013.053-3.053h2.868v.833a2.13 2.13 0 002.127 2.128h8.882a2.13 2.13 0 002.128-2.128v-.833h2.868a3.057 3.057 0 013.053 3.053v21.28a3.057 3.057 0 01-3.053 3.052z"
        fill="#E6E6E6"
      />
      <Path
        d="M33.004 99.08h-7.403v-8.547L15.933 75.71l6.2-4.043 9.626 14.76a6.697 6.697 0 011.087 3.546l.158 9.108z"
        fill="#E6E6E6"
      />
      <Path d="M19.958 104.723h-7.216V83.074h7.216v21.649z" fill="#E6E6E6" />
      <Path
        d="M28.992 85.11H13.079a1.575 1.575 0 01-1.573-1.573v-5.921a1.575 1.575 0 011.573-1.573h15.913a1.575 1.575 0 011.573 1.573v5.92a1.575 1.575 0 01-1.573 1.574z"
        fill="#E6E6E6"
      />
      <Path
        d="M34.298 102.503h-8.604v-5.736h8.604a2.868 2.868 0 110 5.736zM21.346 104.723h-8.604v-5.736h8.604a2.868 2.868 0 010 5.736z"
        fill="#CCC"
      />
      <Path
        d="M30.042 60.685h-6.846a.648.648 0 010-1.295h6.846a.648.648 0 010 1.295zM30.042 62.998h-6.846a.648.648 0 010-1.295h6.846a.648.648 0 010 1.295z"
        fill="#fff"
      />
      <Path
        d="M41.707 104.816H1.185a.185.185 0 01-.13-.055.184.184 0 01.13-.315h40.522a.184.184 0 01.185.185.185.185 0 01-.185.185z"
        fill="#3F3D56"
      />
      <Path
        d="M55.022 53.376a3.33 3.33 0 100-6.66 3.33 3.33 0 000 6.66z"
        fill="#E6E6E6"
      />
      <Path
        d="M56.04 63.46a1.111 1.111 0 01-1.11-1.11V22.383a1.11 1.11 0 112.22 0V62.35a1.111 1.111 0 01-1.11 1.11z"
        fill="#3F3D56"
      />
      <Path
        d="M89.745 21.613c-.975-.852-4.324-3.508-8.645-3.992-3.232-.361-7.009.492-10.74 4.226-2.995 2.993-5.818 4.413-8.394 4.22-2.63-.198-4.378-2.067-5.186-3.164a.452.452 0 00-.513-.163.458.458 0 00-.32.44v13.815a.465.465 0 00.264.419c1.009.477 4.641 2.063 8.297 2.063 2.145 0 4.3-.546 5.936-2.184l.048-.046c2.898-2.82 9.285-2.24 13.946-1.32a54.5 54.5 0 014.528 1.102.832.832 0 001.062-.8V22.241a.835.835 0 00-.283-.628z"
        fill="#E40046"
      />
      <Path
        d="M97.21 60.963a1.665 1.665 0 100-3.331 1.665 1.665 0 000 3.33zM94.249 79.281a1.665 1.665 0 100-3.33 1.665 1.665 0 000 3.33zM88.883 67.809a2.775 2.775 0 100-5.551 2.775 2.775 0 000 5.55z"
        fill="#fff"
      />
    </Svg>
  );
}

export default SvgComponent;
